import { render, staticRenderFns } from "./ScheduleDemo.vue?vue&type=template&id=6972a7c9&scoped=true"
import script from "./ScheduleDemo.vue?vue&type=script&lang=js"
export * from "./ScheduleDemo.vue?vue&type=script&lang=js"
import style0 from "./ScheduleDemo.vue?vue&type=style&index=0&id=6972a7c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6972a7c9",
  null
  
)

export default component.exports